/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerAppResourceReadRequest
 */
export interface PlannerAppResourceReadRequest {
    /**
     * 
     * @type {string}
     * @memberof PlannerAppResourceReadRequest
     */
    uri: string;
}

/**
 * Check if a given object implements the PlannerAppResourceReadRequest interface.
 */
export function instanceOfPlannerAppResourceReadRequest(value: object): value is PlannerAppResourceReadRequest {
    if (!('uri' in value) || value['uri'] === undefined) return false;
    return true;
}

export function PlannerAppResourceReadRequestFromJSON(json: any): PlannerAppResourceReadRequest {
    return PlannerAppResourceReadRequestFromJSONTyped(json, false);
}

export function PlannerAppResourceReadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerAppResourceReadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'uri': json['uri'],
    };
}

export function PlannerAppResourceReadRequestToJSON(json: any): PlannerAppResourceReadRequest {
    return PlannerAppResourceReadRequestToJSONTyped(json, false);
}

export function PlannerAppResourceReadRequestToJSONTyped(value?: PlannerAppResourceReadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uri': value['uri'],
    };
}

